//rate-api.js
import axios from 'axios'
import { API_URL } from '@/config/api.config'

const rateAPI = {
    /**
     * 获取营地评价列表（分页）
     */
    getRateList: async (page = 1, perPage = 10) => {
        try {
            const response = await axios.get(`${API_URL}/rate`, {
                params: { page, per_page: perPage }
            });
            return response.data;
        } catch (error) {
            console.error('获取评价列表失败:', error);
            throw error;
        }
    },

    /**
     * 更新评价状态
     */
    updateRateStatus: async (rateId, newStatus) => {
        try {
            const response = await axios.put(`${API_URL}/rate/${rateId}/status`, { status: newStatus });
            return response.data;
        } catch (error) {
            console.error('更新评价状态失败:', error);
            throw error;
        }
    },

    /**
     * 删除评价
     */
    deleteRate: async (rateId) => {
        try {
            const response = await axios.delete(`${API_URL}/rate/${rateId}`);
            return response.data;
        } catch (error) {
            console.error('删除评价失败:', error);
            throw error;
        }
    }
};

export default rateAPI;